import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor() { }

  private messageSucessSource = new BehaviorSubject<[number, string]>(null);
  currentSucessMessage = this.messageSucessSource.asObservable();
  private messageErrorSource = new BehaviorSubject<[number, string]>(null);
  currentErrorMessage = this.messageErrorSource.asObservable();
  private sendingFileProgress = new BehaviorSubject<[number, number]>(null);
  currentFileProgress = this.sendingFileProgress.asObservable();

  changeSucessMessage(index: number, message: string) {
    this.messageSucessSource.next([index, message]);
  }

  changeErrorMessage(index: number, message: string) {
    this.messageErrorSource.next([index, message]);
  }

  changeFileProgress(index: number, progress: number) {
    this.sendingFileProgress.next([index, progress]);
  }
}
